import styled from '@emotion/styled';
import React from 'react';
import { USPProps } from '../Summary.definitions';
import Checkmark from '~/icons/checkmark.svg';
import { StyledRichText } from '~/shared/components/RawHtml/styled';
import { Typography } from '~/shared/components/Typography';

const USPsWrapper = styled.div(() => ({
    overflow: 'hidden',
    position: 'relative',
}));

const Usp = styled.ul(({ theme }) => ({
    li: {
        '&:last-child': {
            paddingBottom: 0,
        },
        paddingBottom: theme.space[1],
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: theme.space[2],
        svg: {
            marginTop: 2,
            flexShrink: 0,
        },
    },
    [`${StyledRichText}`]: {
        'p,ul': {
            marginBottom: theme.space[1],
        },
        strong: {
            fontWeight: theme.mixins.useFontWeight('Medium'),
        },
    },
    '.textRawHtml_customStyle': {
        ...theme.mixins.useTextStyle('bodySmall'),
    },
}));

export const USPs = ({ usps }: USPProps) => {
    if (!usps) return null;
    return (
        <USPsWrapper>
            <Usp>
                {usps.map((usp, index) => (
                    <Typography variant="paragraph-S" as="li" key={index}>
                        <Checkmark />

                        <span>
                            <strong>{usp.headline}</strong>

                            {/* Separate headline and text by hyphen (-) if both are available. */}
                            {usp.headline && usp.text && ' - '}

                            {usp.text}
                        </span>
                    </Typography>
                ))}
            </Usp>
        </USPsWrapper>
    );
};
